import { render } from "./CiviLifeNewsType.vue?vue&type=template&id=4631e7ef"
import script from "./CiviLifeNewsType.vue?vue&type=script&lang=js"
export * from "./CiviLifeNewsType.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTL-Project\\Mbf5_HCC\\XaQuangHa\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__